import { useMemo } from 'react';

import { setCheckedGrades, useCheckedGrades } from 'reducers/viewsSlice';

import { VIEWS_FILTER_KEYS } from 'constants/ProjectConstants';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

import { useGrades } from '../../Hooks/dataHooks';
import { AgGridContainer } from './AgGridContainer';

const CellRenderer = ({ data: grade }) => (
  <ListItemComp title={grade.name} isBoldText={false} withoutBackground padding="16px 24px" />
);

// const getRowId = (data) => {
//   return data.uuid;
// };

export const Grades = () => {
  const { data: grades, isLoading } = useGrades();
  const checkedGrades = useCheckedGrades();

  const checkedRowsSet = useMemo(() => new Set(checkedGrades?.map((c) => c.id) ?? []), [checkedGrades]);

  const columnDefs = useMemo(
    () => [
      {
        colId: VIEWS_FILTER_KEYS.GRADE,
        flex: 1,
        cellRenderer: CellRenderer,
        getQuickFilterText: (params) => params.data.name,
        sortable: true,
        comparator: (_valueA, _valueB, nodeA, nodeB, isDescending) => {
          const a = nodeA.data.name;
          const b = nodeB.data.name;
          // these checks are for moving checked rows to the top
          if (checkedRowsSet.has(nodeA.data.uuid) && checkedRowsSet.has(nodeB.data.uuid)) {
            return a.localeCompare(b);
          }
          if (checkedRowsSet.has(nodeA.data.uuid)) {
            return isDescending ? 1 : -1;
          }
          if (checkedRowsSet.has(nodeB.data.uuid)) {
            return isDescending ? -1 : 1;
          }
          return a.localeCompare(b);
        },
      },
    ],
    [checkedRowsSet]
  );

  return (
    <AgGridContainer
      rowData={grades}
      columnDefs={columnDefs}
      setCheckedRows={setCheckedGrades}
      sortColumnId={VIEWS_FILTER_KEYS.GRADE}
      checkedRows={checkedGrades}
      rowCheckedTesterFn={({ nodeData, checkedRows }) => {
        const { uuid } = nodeData || {};
        const checked = checkedRows?.find(({ id }) => id === uuid);
        return !!checked;
      }}
    />
  );
};
